export default __webpack_public_path__ + "static/media/case-study1.911c2f8c.jpg";